export default class Stationery {
    static fromData(data) {
        if (!data) {
            return;
        }

        const stationery = new Stationery();
        stationery.id = data.id;
        stationery.name = data.name;
        stationery.type = data.type;
        stationery.templates = data.templates ?? [];
        stationery.isAllowedToEdit = data.isAllowedToEdit;

        return stationery;
    }
}
